import { GenericEditCost } from './Generic'

export const EditBudget = ({
  data: dataSchemaTable,
  editType,
  strategy,
  isEdit,
  origin,
  initialCostOverride,
  onRequestEdit,
  onCancel
}: EditBudgetProxyProps) =>
  strategy !== 'objective_based' ? (
    <GenericEditCost
      dataSchemaTable={dataSchemaTable}
      type={editType}
      isEdit={isEdit}
      origin={origin}
      initialCostOverride={initialCostOverride}
      onRequestEdit={onRequestEdit}
      onCancel={onCancel}
    />
  ) : (
    <></>
  )
